import React, { FC, Fragment } from 'react';
import { QueryResult } from 'react-apollo';

import { QuerySearchArgs, SearchPeopleDocument } from 'api';
import { Queries } from 'components';

import Loader from './Loader';
import Table from './Table';

interface IProps {
  className: string;
  columns: any;
  variables: Partial<QuerySearchArgs>;
  onSetTotal: (count: number) => void;
}

const SearchTable: FC<IProps> = ({ className, columns, variables, onSetTotal }) => {
  function handleQueryCompleted(data: QueryResult['data']) {
    const { search } = data;
    onSetTotal(search.count);
  }

  return (
    <Queries.Search
      fetchPolicy="network-only"
      loader={<Loader rows={8} />}
      document={SearchPeopleDocument}
      variables={variables}
      onCompleted={handleQueryCompleted}>
      {({ count, exhausted, results, onLoadMore }) => (
        <Fragment>
          <Table
            emptyStateName="searchUsers"
            className={className}
            columns={columns(results)}
            profiles={results}
            count={count}
            onLoadMore={onLoadMore}
          />
          {!exhausted && <Loader rows={1} />}
        </Fragment>
      )}
    </Queries.Search>
  );
};

export default SearchTable;
